interface Props {}

const AboutPage = ({}: Props) => {

  return (
    <>
      <title>About | Tuttobanana</title>
      <meta name="description" content="Tuttobanana is a joyful way to send digital bananas packed with love, laughter, and connection. One tiny gift, big feeling." />
      <div className="bg-gray-100 text-gray-900 px-6 py-20 sm:px-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-8 text-yellow-500 text-center">
            About Tuttobanana
          </h1>
          <p className="text-lg text-gray-800 mb-6">
            Tuttobanana is the internet's most joyful expression platform, a playful way to send tiny digital gifts packed with big emotions.
          </p>

          <p className="text-lg text-gray-800 mb-6">
            In a world of endless scrolling and dry texts, Tuttobanana makes sharing gratitude, encouragement, or celebration feel personal, instant, and fun.
          </p>

          <p className="text-lg text-gray-800 mb-6">
            Each animated banana is unique, personalized with your message, and tagged with your location. Bananas can be "banana'd forward" to others or even sent back to you. As they travel, they form chains of connection, building what we call the <strong>Bananaverse</strong>.
          </p>

          <p className="text-lg text-gray-800 mb-6">
            We believe in frictionless joy. That's why you don't need an account to receive bananas, and sending them is fast, free, and satisfying.
          </p>

          <p className="text-lg text-gray-800 mb-6">
            Our long-term mission? Make Tuttobanana the world's most smile-inducing micro-gifting platform, with joyful bananas riding a wave of what we call <strong>Bananergy</strong>.
          </p>

          <div className="mt-12 text-center">
            <p className="text-xl font-semibold text-yellow-600">
              Tiny Gift. Big Feeling. 🍌
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage;
